// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  chart: "HeroChart__chart",
  "ef-hero-dash": "HeroChart__ef-hero-dash",
  fanLine: "HeroChart__fanLine",
  gridIn: "HeroChart__gridIn",
  "hero-grid-in": "HeroChart__hero-grid-in",
  svg: "HeroChart__svg",
};
